module.exports = __webpack_public_path__ + "img/status-icn_expired@3x.8d95515f.png";